'use strict';

let UAParser = require('ua-parser-js');

// 加速度センサの情報を取得
let accXs       = [];
let accTryCount = 0;
function appendAccelerationX(event){
  let x = parseFloat(event.acceleration.x);
  if(x){
    accXs.push(x);
  }
}
window.addEventListener('devicemotion', appendAccelerationX);
let intervalId = window.setInterval(function(){
  accTryCount++;
  if(accXs.length > 0 || accTryCount > 100){
    window.removeEventListener('devicemotion', appendAccelerationX);
    window.clearInterval(intervalId);
  }
}, 100);

/**
 * ユーザエージェントからスマホかとかAndroidかを判別するライブラリ
 */
export default {
  /**
   * スマホかどうか
   * @returns {boolean}
   */
  isSmartPhone(){
    let ua = window.navigator.userAgent;
    return !!((/Android/.test(ua) || /iPhone/.test(ua) || /iPod/.test(ua) || /iPad/.test(ua)) && window.history.pushState);
  },
  
  /**
   * Apple系のデバイスか
   * @returns {boolean}
   */
  isAppleDevice(){
    let ua = window.navigator.userAgent;
    return /iPhone/.test(ua) || /iPod/.test(ua) || /iPad/.test(ua);
  },
  
  /**
   * Androidか
   * @returns {boolean}
   */
  isAndroid(){
    let ua = window.navigator.userAgent;
    return /Android/.test(ua);
  },
  
  /**
   * Androidの古い標準ブラウザかどうか
   * http://qiita.com/narikei/items/ada44891cb0902efc165
   * @returns {boolean}
   */
  isAndroidOldBrowser(){
    let ua = window.navigator.userAgent;
    return /Android/.test(ua) && /Linux; U;/.test(ua) && !/Chrome/.test(ua);
  },
  
  /**
   * Chromeでかつ<audio><video>タグでダウンロードボタンが表示されるバージョンか
   * @returns {boolean}
   */
  isChromeWithDownloadButton(){
    var match = navigator.userAgent.match(/Chrome\/(\d+)/);
    return match && parseInt(match[1]) >= 55;
  },
  
  /**
   * スマホかどうかをwindow.navigation.platformを利用して判断する
   * @returns {boolean}
   */
  isSmartPhoneByPlatform(){
    let platform = window.navigator.platform;
    return /Linux a/.test(platform) ||  // Linux armv7l, Linux armv8l, Linux aarch64
      /Linux x86/.test(platform) || // Linux x86_64
      /iP/.test(platform); //iPhone, iPad, iPod touch
  },
  
  /**
   * スマホかどうかを加速度センサの値で確認する
   * @returns {boolean}
   */
  isSmartPhoneByAcceleration(){
    return accXs.length > 0;
  },
  
  /**
   * UAからいろんな情報を取得
   * @param ua
   * @returns {{os: *, osVersion: String, osVersionMajor: *, device: *, browser: *, browserVersion: String, browserVersionMajor: *}}
   */
  getUserAgentData: function(ua){
    //ua = 'Mozilla/5.0 (Linux; Android 6.0.1; 601SO Build/39.0.D.0.327) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/56.0.2924.87 Mobile Safari/537.36';
    //ua = 'Mozilla/5.0 (Linux; Android 4.2.1; HY5001 Build/JOP40D) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/28.0.1500.64 Mobile Safari/537.36';
    //ua = 'Mozilla/5.0 (iPhone; CPU iPhone OS 9_1 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13B143 Safari/601.1';
    //ua = 'Mozilla/5.0 (Linux; Android 5.1; ASUS_Z00VD Build/LMY47I) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/54.0.2840.85 Mobile Safari/537.36';
    //ua = 'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/56.0.2924.87 Mobile Safari/537.36';
    
    let parser = new UAParser();
    let agent  = parser.setUA(ua);
    let deviceName = (agent.getDevice() && agent.getDevice().model) || 'NO_DEVICE';
    
    let regexp = new RegExp('Android[\\- ][\\d]+(?:\\.[\\d]+){1,2}; (.*) Build[/ ]');
    if(regexp.test(ua)){
      let matchStr = ua.match(regexp);
      
      if(matchStr.length >= 2){
        deviceName = matchStr[1];
      }
    }
    
    return {
      os:             agent.getOS() && agent.getOS().name,
      osVersion:      agent.getOS() && agent.getOS().version,
      device:         deviceName,
      browser:        agent.getBrowser() && agent.getBrowser().name,
      browserVersion: agent.getBrowser() && agent.getBrowser().version
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/user-agenet.js